export const state = {
  type: 'all',
  page: 1,
  pageSize: 20,
  order: 'createdAt DESC',
  searchByData: '',
  searchByType: '',
}

export const mutations = {
  CHANGE_TYPE(state, type) {
    state.type = type;
  },
  CHANGE_PAGE(state, page) {
    state.page = page;
  },
  CHANGE_PAGE_SIZE(state, pageSize) {
    state.pageSize = pageSize
  },
  CHANGE_ORDER(state, orderBy) {
    state.order = orderBy
  },
  CHANGE_SEARCHBY_DATA(state, data) {
    state.searchByData = data
  },
  CHANGE_SEARCHBY_TYPE(state, type) {
    state.searchByType = type
  }
}

export const getters = {
  getSearchType(state) {
    return state.type;
  },
  getSearchPage(state) {
    return state.page;
  },
  getSearchPageSize(state) {
    return state.pageSize;
  },
  getSearchOrder(state) {
    return state.order;
  },
  getSearchByData(state) {
    return state.searchByData;
  },
  getSearchByType(state) {
    return state.searchByType;
  }
}

export const actions = {
  changeType({ commit }, { type }) {
    commit('CHANGE_TYPE', type);
  },

  changePage({ commit }, { page }) {
    commit('CHANGE_PAGE', page)
  },

  changePageSize({ commit }, { pageSize }) {
    commit('CHANGE_PAGE_SIZE', pageSize)
  },

  changeOrder({ commit }, { order }) {
    commit('CHANGE_ORDER', order)
  },

  changeSearchByData({ commit }, { data }) {
    commit('CHANGE_SEARCHBY_DATA', data)
  },

  changeSearchByType({ commit }, { type }) {
    commit('CHANGE_SEARCHBY_TYPE', type)
  }
}
